// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"folder-import"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M13 20H22V6H11L9 3.5H2V11.75","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M6.0419 21.502L9.50211 18.0019L6.0419 14.502M8.3 18.002H0.998047","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const FolderImportIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'folder-import',
    ref,
    icon: element,
  },
));

FolderImportIcon.displayName = 'FolderImportIcon';

export default FolderImportIcon;
